import React, { useState, useRef, useEffect } from 'react';
import { FaArrowRight, FaChevronDown } from 'react-icons/fa';
import './Service.css';

const commercial = [
  {
    title: 'Turf Installation',
    img: `${process.env.PUBLIC_URL}/turf.png`,
    description: 'Professional turf-installation services for properties',
    link: '/services/turf-installation'
  },
  {
    title: 'Irrigation',
    img: `${process.env.PUBLIC_URL}/irrigation.png`,
    description: 'Expert irrigation systems that keep your lawn lush',
    link: '/services/irrigation'
  },
  {
    title: 'Lawn Recovery',
    img: `${process.env.PUBLIC_URL}/lwn.jpeg`,
    description: 'Comprehensive process ensures optimal lawn health',
    link: '/services/lawn-recovery-package'
  },
  {
    title: 'Sod Installation',
    img: `${process.env.PUBLIC_URL}/sodd.jpeg`,
    description: 'Professional sod installation for a beautiful lawn',
    link: '/services/sod-installation'
  },
];

const maintenanceOptions = [
  { text: 'Residential', link: '/services/residential-maintenance' },
  { text: 'HOA', link: '/services/hoa-maintenance' },
  { text: 'Commercial', link: '/services/commercial-maintenance' }
];

function ServiceCard({ title, img, description, link }) {
  return (
    <div className="svc-card">
      <div className="svc-card__img-container">
        <img 
          src={img} 
          alt={title} 
          className="svc-card__img" 
          loading="lazy"
        />
        <div className="svc-card__overlay">
          <div className="svc-card__content">
            <h3 className="svc-card__title">{title}</h3>
            <p className="svc-card__description">{description}</p>
            <a href={link} className="svc-card__btn">
              <span>Explore</span>
              <FaArrowRight className="svc-card__icon" />
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}

export default function Service() {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const btnWrapRef = useRef(null);

  const toggleDropdown = () => setDropdownOpen(v => !v);
  const closeDropdown = () => setDropdownOpen(false);

  // Close on outside click
  useEffect(() => {
    const onDocClick = (e) => {
      if (!btnWrapRef.current?.contains(e.target)) closeDropdown();
    };
    document.addEventListener('click', onDocClick);
    return () => document.removeEventListener('click', onDocClick);
  }, []);

  // Close on Escape
  useEffect(() => {
    const onKey = (e) => e.key === 'Escape' && closeDropdown();
    document.addEventListener('keydown', onKey);
    return () => document.removeEventListener('keydown', onKey);
  }, []);

  return (
    <section className="services" id="services">
      <div className="services__container">
        <div className="services__header">
          <h2 className="services__heading">
            <span className="heading-highlight">Premium</span> Landscape Services
          </h2>
          <div className="services__divider"></div>
        </div>

        {/* Maintenance Section */}
        <div 
          className="maintenance-section"
          style={{ backgroundImage: `url(${process.env.PUBLIC_URL}/resedential-header.jpg)` }}
        >
          <div className="maintenance-overlay" aria-hidden="true"></div>
          
          <div className="maintenance-content">
            <div className="maintenance-text">
              <h3 className="maintenance-title">Landscaping Maintenance</h3>
              <p className="maintenance-subtitle">
                Beautiful yards tailored for every property
              </p>
            </div>

            <div 
              className={`maintenance-btn-container ${dropdownOpen ? 'dropdown-open' : ''}`}
              ref={btnWrapRef}
            >
              <button
                onClick={toggleDropdown}
                className="maintenance-btn"
                aria-expanded={dropdownOpen}
                aria-haspopup="menu"
                aria-controls="maintenance-dropdown"
              >
                <span>Explore Options</span>
                <FaChevronDown className={`btn-icon ${dropdownOpen ? 'rotate' : ''}`} />
              </button>

              <div
                id="maintenance-dropdown"
                className={`maintenance-dropdown ${dropdownOpen ? 'show' : ''}`}
                role="menu"
              >
                {maintenanceOptions.map((item, index) => (
                  <a
                    key={index}
                    href={item.link}
                    className="dropdown-item"
                    role="menuitem"
                    onClick={closeDropdown}
                  >
                    {item.text}
                  </a>
                ))}
              </div>
            </div>
          </div>
        </div>

        {/* Services Grid */}
        <div className="services__category">
       
          <div className="services__grid services__grid--commercial">
            {commercial.map((card) => (
              <ServiceCard 
                key={`${card.title}-${card.description}`}
                title={card.title}
                img={card.img}
                description={card.description}
                link={card.link}
              />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
